import { post } from "./http";
import { API_URL } from "lib/http";

const COLLECTION_FILE_URL = `${API_URL}/murfy-erp/public/collection-files`;
const COLLECTION_FILE_TOKEN_STORAGE_KEY = "collectionFileToken";
const COLLECTION_FILE_ID_STORAGE_KEY = "collectionFileId";

export const create = async (payload) => {
  try {
    const jsonData = await post("/murfy-erp/collection-files/submit/", payload);
    if (jsonData.status !== 201) {
      return { data: jsonData.data, error: null };
    }
    window.sessionStorage.setItem(COLLECTION_FILE_TOKEN_STORAGE_KEY, JSON.stringify(jsonData.data["token"]));
    window.sessionStorage.setItem(COLLECTION_FILE_ID_STORAGE_KEY, JSON.stringify(jsonData.data["file_id"]));
    return { data: jsonData.data["items"], error: null };
  } catch (error) {
    return { response: null, error };
  }
};
const getHeaders = () => {
  const myHeaders = new Headers();
  const token = JSON.parse(window.sessionStorage.getItem(COLLECTION_FILE_TOKEN_STORAGE_KEY));
  myHeaders.append("Authorization", `${token}`);
  myHeaders.append("Content-Type", "application/json");
  return myHeaders;
};

const getUpdateUrl = () => {
  const fileId = JSON.parse(window.sessionStorage.getItem(COLLECTION_FILE_ID_STORAGE_KEY));
  return `${COLLECTION_FILE_URL}/${fileId}/`;
};

export const update = (data) => {
  let encodedData;
  const formData = new FormData();
  Object.entries(data).forEach((value) => formData.append(...value));
  encodedData = formData;
  encodedData = JSON.stringify(data);

  const headers = getHeaders();
  return fetch(getUpdateUrl(), { headers, method: "PATCH", body: encodedData }).then((response) => {
    if (response.ok) {
      response.json();
    } else {
      const error = new Error(
        `API call for ${COLLECTION_FILE_URL} failed: ${response.statusText} (${response.status})`
      );
      error.code = response.status;
      throw error;
    }
  });
};
